module.exports = __webpack_public_path__ + "3_Student_Dashboard-998fdca0d6b5d2f0c133d9a137d31c9e.jpg";